import { localizedLegalPage } from "./localized";
import { TermsPage as Fr } from "./fr/TermsPage";
import { TermsPage as En } from "./en/TermsPage";

export const TermsPage = localizedLegalPage({ fr: Fr, en: En });

export default TermsPage;
